import Vue from "vue";
import App from "./App.vue";
import Slash from "./Slash.vue";
import ErrorComponent from "./Error.vue";
import router from "./router";
import store from "./store/store";

import "./plugins";
import "./global-components";

import axios from "axios";
import _ from "lodash";
import * as helper from "./utils/api/helper";
import * as providerEnum from "./utils/provider";
import api from "./utils/api/url";
import service from "./utils/api/service";
import { loadMasterData } from "./utils/loadMasterData";

// Global properties
Vue.prototype.$axios = axios;
Vue.prototype.$helper = helper.default;
Vue.prototype.$_ = _;
Vue.prototype.$provider = providerEnum;

// Global directive
Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

// Capitalize utility
Vue.prototype.$capitalize = function (str) {
  return typeof str === "string"
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str;
};

Vue.config.productionTip = false;

let app = new Vue({
  router,
  store,
  render: (h) => h(Slash),
}).$mount("#app");

(async () => {
  let response;
  const tokenKey = helper.default?.tokenEnum()?.access_token;
  const token = localStorage.getItem(tokenKey) || "";

  if (!token) {
    destroyAndMount(App);
    return;
  }

  loadMasterData();

  try {
    response = await axios.get(
      api.adminAccount + "/profile",
      service.headers(),
    );

    if (response?.data?.data) {
      store.dispatch("storeAccountInfo", response.data.data);
      destroyAndMount(App);
    }
  } catch (error) {
    const statusCode =
      error.response?.data?.statusCode || error.response?.status;

    if (statusCode === "4410" || statusCode === 4410) {
      try {
        const refreshResult = await service.refreshToken();

        if (refreshResult === "ok") {
          const retryResponse = await axios.get(
            api.adminAccount + "/profile",
            service.headers(),
          );

          if (retryResponse?.data?.data) {
            store.dispatch("storeAccountInfo", retryResponse.data.data);
            destroyAndMount(App);
            return;
          }
        }
      } catch (refreshErr) {
        // console.error("Token refresh failed", refreshErr);
      }
    }

    Vue.prototype.$master = {};
    destroyAndMount(ErrorComponent);
  }
})();

function destroyAndMount(Component) {
  if (app && app.$destroy) {
    app.$destroy();
  }
  const el = document.getElementById("app");
  if (el) el.innerHTML = "";

  app = new Vue({
    router,
    store,
    render: (h) => h(Component),
  }).$mount("#app");
}
